import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-pl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-pl.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { ViewApplicationService } from "../../../view-application.service";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import GeometryUtils from "../../../../../shared/utils/geometry-utils";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import Query from "@arcgis/core/rest/support/Query";
import { MapService } from "../../../../../map/shared/map.service";
import { MapTools } from "../../../../../map/shared/map.tools";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { ViewApplicationDetailsPlConstants } from "../view-application-details-pl/view-application-details-pl.constants";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { PropertyAndLeaseService } from "../../../../../shared/services/modules/property-and-lease.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationLocationPlConstants } from "./view-application-location-pl.constants";
import { debounceTime } from "rxjs";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
let ViewApplicationLocationPlComponent = class ViewApplicationLocationPlComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    routerParamsService;
    mapService;
    mapTools;
    appController;
    propertyAndLeaseService;
    recipientListService;
    requestStatusService;
    changeDetectorRefs;
    viewApplicationService;
    active;
    propertiesForm;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    validationMessages = ViewApplicationLocationPlConstants.VALIDATION_MESSAGES;
    descriptionLabel1 = ViewApplicationLocationPlConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationPlConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationPlConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationPlConstants.DESCRIPTION_LABEL_4;
    descriptionLabel5 = ViewApplicationLocationPlConstants.DESCRIPTION_LABEL_5;
    erfNoControl = ViewApplicationLocationPlConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationPlConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationPlConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationPlConstants.FARM_NO_CONTROL;
    zoningControl = ViewApplicationLocationPlConstants.ZONING_CONTROL;
    streetNumberControl = ViewApplicationLocationPlConstants.STREET_NO_CONTROL;
    streetNameControl = ViewApplicationLocationPlConstants.STREET_NAME_CONTROL;
    townControl = ViewApplicationLocationPlConstants.TOWN_CONTROL;
    sgCodeControl = ViewApplicationLocationPlConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationPlConstants.ADDRESS_CONTROL;
    ownerControl = ViewApplicationLocationPlConstants.OWNER_CONTROL;
    leaseAreaControl = ViewApplicationLocationPlConstants.LEASE_AREA_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationPlConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationPlConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationPlConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationPlConstants.FARM_NO_TEXT_PLACEHOLDER;
    zoningControlTextPlaceHolder = ViewApplicationLocationPlConstants.ZONING_TEXT_PLACEHOLDER;
    streetNumberTextPlaceHolder = ViewApplicationLocationPlConstants.STREET_NO_TEXT_PLACEHOLDER;
    streetNameTextPlaceHolder = ViewApplicationLocationPlConstants.STREET_NAME_TEXT_PLACEHOLDER;
    townTextPlaceHolder = ViewApplicationLocationPlConstants.TOWN_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationPlConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationPlConstants.ADDRESS_TEXT_PLACEHOLDER;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    ownerLabel = ViewApplicationLocationPlConstants.OWNER_LABEL;
    copyApplicantToOwnerZoneLabel = ViewApplicationLocationPlConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = ViewApplicationLocationPlConstants.REMOVE_PROPERTY_LABEL;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    ownerListLabel = "Owner";
    mapComponent;
    sketch;
    application;
    isMapLoaded = false;
    getApplicationSavePropertiesObservableSubscription;
    getStepMetaObservableSubscription;
    selectedPropertySubscription;
    constructor(aflaModuleStrategyService, route, routerParamsService, mapService, mapTools, appController, propertyAndLeaseService, recipientListService, requestStatusService, changeDetectorRefs, viewApplicationService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.mapService = mapService;
        this.mapTools = mapTools;
        this.appController = appController;
        this.propertyAndLeaseService = propertyAndLeaseService;
        this.recipientListService = recipientListService;
        this.requestStatusService = requestStatusService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.viewApplicationService = viewApplicationService;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        this.getMetadata();
        this.subscribeToProperty();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    handleRouteChange() {
        // this.getMetadata();
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.sketch = this.mapTools.getMapTool("drawTool");
        const appType = this.aflaModuleStrategyService.form.get("detailsForm").get("applicationType").value;
        if (appType !== null && appType.value === "Lease") {
            this.mapTools.expandWidget("drawTool");
            this.sketch.create("polygon");
        }
        this.sketch.on("create", (event) => {
            if (event.state === "start") {
                this.mapService.showPopups = false;
            }
            if (event.state === "complete") {
                this.mapService.showPopups = true;
                if (event.graphic.geometry.type === "polygon") {
                    this.propertiesForm.get("leaseArea").setValue(event.graphic.geometry);
                }
            }
            else if (event.state === "cancel") {
                this.mapService.showPopups = true;
            }
            else {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
        if (this.propertiesForm.get("leaseArea").value !== null) {
            this.mapComponent.addGeometriesOnMap([GeometryUtils.mapGeometryToDTO(this.propertiesForm.get("leaseArea").value)], "Draw Tool Layer");
        }
    }
    getProperties() {
        return this.propertiesForm.get("properties");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnSaveClicked($event) {
        if (this.propertiesForm.valid) {
            const appType = this.aflaModuleStrategyService.form.get("detailsForm").get("applicationType").value;
            let polygonDrawn = true;
            let leaseAreaGeometryJSON = null;
            if (appType !== null && appType.value === "Lease") {
                const leaseAreaGeometry = this.propertiesForm.get("leaseArea").value;
                if (leaseAreaGeometry === null) {
                    this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
                    return null;
                }
                leaseAreaGeometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(leaseAreaGeometry);
            }
            const points = [];
            const properties = [];
            const propertiesArray = this.propertiesForm.get("properties");
            for (const property of propertiesArray.controls) {
                if (!property.value.hasOwnProperty("property")) {
                    polygonDrawn = false;
                    break;
                }
            }
            if (!polygonDrawn) {
                this.appController.showMessage("Please draw an area (polygon) around the lease area on the location tab.", AlertType.Warning);
                return;
            }
            propertiesArray.controls.forEach((item) => {
                const centroid = item.get("centroid").value;
                points.push(`(${centroid.x} ${centroid.y})`);
                const geometry = item.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                const owners = item.get("owners").value.recipients;
                owners.forEach((owner) => {
                    owner = RecipientUtils.removeRecipientProperties(owner);
                });
                const property = {
                    address: item.get("address").value,
                    allotment: item.get("allotment").value,
                    erfNumber: item.get("erfNo").value,
                    farmNumber: item.get("farmNo").value,
                    zoning: item.get("zoning").value,
                    streetNumber: item.get("streetNumber").value,
                    streetName: item.get("streetName").value,
                    town: item.get("town").value,
                    isDummy: false,
                    sgCode: item.get("sgCode").value,
                    shape: geometryJSON,
                    subdivision: item.get("subdivision").value,
                    updateGeometry: false,
                    wkid: 102100,
                    owners,
                };
                properties.push(property);
            });
            const params = {
                properties,
                applicationShape: `MULTIPOINT (${points.join(", ")})`,
                applicationWkid: 102100,
                leaseAreaShape: leaseAreaGeometryJSON
            };
            this.getApplicationSavePropertiesObservableSubscription =
                this.propertyAndLeaseService.getApplicationSavePropertiesObservable(this.application.id, params)
                    .subscribe({ next: appSaveresponse => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    }, error: error => {
                        this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Update);
                    } });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    getApplication() {
        const params = {
            $expand: `properties($expand=owners($expand=groups)),leaseAreas,applicant($expand=groups)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe({ next: (response) => this.onGetApplicationCompleted(response), error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsPlConstants.STEP_TITLE, error, CRUDOperation.Get);
            } });
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    initForm() {
        this.propertiesForm = this.aflaModuleStrategyService.form.get("propertiesForm");
    }
    getMetadata() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        this.ownerGroups = stepMeta.ownerGroup;
        if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
            this.ownerGroups = this.recipientListService.checkStepMetaRecipientGroups(this.ownerGroups);
        }
        this.getApplication();
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(ViewApplicationLocationPlConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                zoning: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Zoning", "zoning"), [Validators.required]),
                streetNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "StreetNumber", "streetnumber"), [Validators.required]),
                streetName: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "StreetName", "streetname"), [Validators.required]),
                town: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Town", "town"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                owners: new FormControl(null)
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.viewApplicationService.getTrueCentroid(url, formData)
                .subscribe({ next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.getPropertyOwners(sgCode, newProperty);
                }, error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(ViewApplicationLocationPlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                } });
        }
    }
    getPropertyOwners(sgCode, newProperty) {
        const ownerLayerObj = this.mapService.userMaps.find(a => a.selectionLayerType === "Property owner");
        if (ownerLayerObj !== undefined && ownerLayerObj !== null) {
            const ownerLayer = ownerLayerObj.layer;
            const ownerQuery = new Query();
            ownerQuery.where = `SgCode = '${sgCode}'`;
            ownerQuery.returnGeometry = false;
            ownerQuery.outFields = ["*"];
            ownerLayer.queryFeatures(ownerQuery).then((ownerFeatureSet) => {
                // Make sure the grave centroid is within one cemetery boundary
                const ownersControl = newProperty.get("owners");
                const owners = [];
                if (ownerFeatureSet.features.length > 0) {
                    ownerFeatureSet.features.forEach(item => {
                        try {
                            const newOwner = {
                                name: item.attributes.Name ? item.attributes.Name : item.attributes.name,
                                surname: item.attributes.Surname ? item.attributes.Surname : item.attributes.surname,
                                telephone: item.attributes.Telephone ? item.attributes.Telephone : item.attributes.telephone,
                                email: item.attributes.Email ? item.attributes.Email : item.attributes.email,
                                defaultCommunicationMethod: item.attributes.DefaultCommunicationMethod ? item.attributes.DefaultCommunicationMethod : item.attributes.defaultcommunicationmethod,
                                postalAddress: item.attributes.PostalAddress ? item.attributes.PostalAddress : item.attributes.postaladdress,
                                designation: item.attributes.Designation ? item.attributes.Designation : item.attributes.designation,
                                organisation: item.attributes.Organisation ? item.attributes.Organisation : item.attributes.organisation,
                                clientVatNumber: item.attributes.ClientVatNumber ? item.attributes.ClientVatNumber : item.attributes.clientvatnumber,
                                streetAddress: item.attributes.StreetAddress ? item.attributes.StreetAddress : item.attributes.streetaddress,
                                homePhone: item.attributes.Homephone ? item.attributes.Homephone : item.attributes.homephone,
                                idNumber: item.attributes.IDNumber ? item.attributes.IDNumber : item.attributes.idnumber,
                                organisationRegistrationNumber: item.attributes.OrganisationRegistrationNumber ? item.attributes.OrganisationRegistrationNumber : item.attributes.organisationregistrationnumber,
                                representative: item.attributes.Representative ? item.attributes.Representative : item.attributes.representative,
                                fax: item.attributes.Fax ? item.attributes.Fax : item.attributes.fax,
                                cellphone: item.attributes.Cellphone ? item.attributes.Cellphone : item.attributes.cellphone,
                                streetSuburb: item.attributes.StreetSuburb ? item.attributes.StreetSuburb : item.attributes.streetsuburb,
                                streetCity: item.attributes.StreetCity ? item.attributes.StreetCity : item.attributes.streetcity,
                                streetProvince: item.attributes.StreetProvince ? item.attributes.StreetProvince : item.attributes.streetprovince,
                                streetCode: item.attributes.StreetCode ? item.attributes.StreetCode : item.attributes.streetcode,
                                postalSuburb: item.attributes.PostalSuburb ? item.attributes.PostalSuburb : item.attributes.postalsuburb,
                                postalCity: item.attributes.PostalCity ? item.attributes.PostalCity : item.attributes.postalcity,
                                postalProvince: item.attributes.PostalProvince ? item.attributes.PostalProvince : item.attributes.postalprovince,
                                postalCode: item.attributes.PostalCode ? item.attributes.PostalCode : item.attributes.postalcode,
                                postalCountry: item.attributes.PostalCountry ? item.attributes.PostalCountry : item.attributes.postalcountry,
                                streetCountry: item.attributes.StreetCountry ? item.attributes.StreetCountry : item.attributes.streetcountry,
                                professionalBody: item.attributes.ProfessionalBody ? item.attributes.ProfessionalBody : item.attributes.professionalbody,
                                professionalBodyRegNum: item.attributes.ProfessionalBodyRegistrationNumber ? item.attributes.ProfessionalBodyRegistrationNumber : item.attributes.professionalbodyregistrationumber,
                                groups: []
                            };
                            owners.push(newOwner);
                        }
                        catch {
                            this.appController.showMessage(ViewApplicationLocationPlConstants.INVALID_OWNER_ATTRIBUTE, AlertType.Error);
                        }
                    });
                }
                const propertyControl = this.getProperties();
                const propertyIndex = propertyControl.length;
                propertyControl.push(newProperty);
                this.active = propertyControl.length - 1;
                this.updateRequiredFields(propertyIndex);
                this.changeDetectorRefs.detectChanges();
                if (owners.length > 0) {
                    this.recipientListService.setRecipients(owners, true, ownersControl);
                }
                this.changeDetectorRefs.detectChanges();
                this.syncMapGeometries();
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }, (error) => {
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
                this.appController.showMessage(error.message, AlertType.Error);
            });
        }
        else {
            const propertyControl = this.getProperties();
            const propertyIndex = propertyControl.length;
            propertyControl.push(newProperty);
            this.active = propertyControl.length - 1;
            this.updateRequiredFields(propertyIndex);
            this.changeDetectorRefs.detectChanges();
            this.syncMapGeometries();
            this.requestStatusService.removeBusySpinner("GetPropertyDate");
        }
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.setPropertyData(property.attributes, property.geometry);
            }
        });
    }
    onGetApplicationCompleted(applicationResponse) {
        if (applicationResponse && applicationResponse.value.length > 0) {
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.application = applicationResponse.value[0];
            this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").setValue(this.application.applicant[0]);
            const geometries = [];
            if (this.application.leaseAreas.length > 0) {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.leaseAreas[0].shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                geometries.push(geom);
            }
            this.application.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                geometries.push(geom);
                const newProperty = new FormGroup({
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber, [Validators.required]),
                    subdivision: new FormControl(property.subdivision, [Validators.required]),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber, [Validators.required]),
                    zoning: new FormControl(property.zoning, [Validators.required]),
                    streetNumber: new FormControl(property.streetNumber, [Validators.required]),
                    streetName: new FormControl(property.streetName, [Validators.required]),
                    town: new FormControl(property.town, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    owners: new FormControl({ recipients: [] }, [Validators.required])
                });
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                this.viewApplicationService.getTrueCentroid(url, formData)
                    .subscribe({ next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        const ownersControl = newProperty.get("owners");
                        this.recipientListService.setRecipients(property.owners, false, ownersControl);
                        this.updateRequiredFields(propertyControl.length - 1);
                        this.changeDetectorRefs.detectChanges();
                        if (this.isMapLoaded === true) {
                            this.syncMapGeometries();
                        }
                    }, error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationPlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    } });
            });
            if (this.isMapLoaded) {
                this.mapComponent.addGeometriesOnMap(geometries, "Property and lease graphics", true);
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    syncMapGeometries() {
        const geometries = [];
        if (this.application.leaseAreas.length > 0) {
            const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(this.application.leaseAreas[0].shape, 102100);
            const geom = JsonUtils.fromJSON(geometryArc);
            geometries.push(geom);
        }
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Property and lease graphics", true);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: MapService },
        { type: MapTools },
        { type: AppControllerService },
        { type: PropertyAndLeaseService },
        { type: RecipientListService },
        { type: RequestStatusService },
        { type: ChangeDetectorRef },
        { type: ViewApplicationService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationPlComponent = __decorate([
    Component({
        selector: "app-view-application-location-pl",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationPlComponent);
export { ViewApplicationLocationPlComponent };
